import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import TitleBanner from './TitleBanner';
import TenantStoriesSection from './TenantStoriesSection';
import LocationDisplay from './LocationDisplay';
import HousingInfoCards from './HousingInfoCards';
import SDAHousingOptions from './SDAHousingOptions';
import TestimonialsSlider from './TestimonialsSlider';

function SdaHomes() {
    const navigate = useNavigate();
    const [sdaLocations, setSdaLocations] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    return (
        <>
            <Helmet>
                <title>SDA Homes | Livability Care</title>
            </Helmet>
            <div className="min-h-screen">
            <TitleBanner image="/Website_Title_Images/SDA.svg" title="Specialist Disability Accommodation" subheading="Discover who we are at Livability Care Australia"/>
            <SDAHousingOptions/>
            {/* <HousingInfoCards/> */}
            {/* <TenantStoriesSection/> */}
            <TenantStoriesSection 
            imgSrc="/PeopleFocusing.jpg" 
            altText="People Focusing" 
            />

                <LocationDisplay/>
                <TestimonialsSlider/>
                
                
                
            </div>
        </>
    );
}

export default SdaHomes;
